var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-user-item__message",attrs:{"data-test":"no-user-item-message"}},[_c('el-card',[_vm._v("Aucun utilisateur")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }